import React from 'react';

const termsSections = [
  {
    title: '1. OVERVIEW',
    content: `This Universal Terms of Service Agreement (this “Agreement”) is entered into by and between Madurai School Education Commission and you, and is made effective as of the date of your use of this website ("Site") or the date of electronic acceptance. This Agreement sets forth the general terms and conditions of your use of the Site and the recruitment, admission, and application services delivered through this Site (individually and collectively, the “Services”). Service-specific agreements and additional policies apply to certain Services and are in addition to (not in lieu of) this Agreement. In the event of a conflict between the provisions of a Service-specific agreement and the provisions of this Agreement, the provisions of the applicable Service-specific agreement shall control.

The terms “we”, “us” or “our” shall refer to Madurai School Education Commission. The terms “you”, “your”, “User” or “applicant” shall refer to any individual or entity who accepts this Agreement, has access to an account, or uses the Services. Nothing in this Agreement shall be deemed to confer any third-party rights or benefits.`,
  },
  {
    title: '2. MODIFICATION OF AGREEMENT, SITE OR SERVICES',
    content: `Madurai School Education Commission may, in its sole discretion, change or modify this Agreement, and any policies or agreements incorporated herein, at any time, and such changes or modifications shall be effective immediately upon posting to this Site. Your use of this Site or the Services after such changes have been posted constitutes your acceptance of this Agreement as last revised. If you do not agree to be bound by this Agreement, do not use or continue to use this Site or the Services.

We may also notify you of changes by email. It is therefore very important that you keep your account information current. We assume no liability or responsibility for your failure to receive an email notification if such failure results from an inaccurate email address. We may terminate your use of Services for any violation or breach of this Agreement. MADURAI SCHOOL EDUCATION COMMISSION RESERVES THE RIGHT TO MODIFY, CHANGE, OR DISCONTINUE ANY ASPECT OF THIS SITE OR THE SERVICES, INCLUDING WITHOUT LIMITATION PRICES AND FEES, AT ANY TIME.`,
  },
  {
    title: '3. ELIGIBILITY; AUTHORITY',
    content: `This Site and the Services are available only to individuals or entities who can form legally binding contracts under applicable law. By using this Site or the Services, you represent and warrant that you are at least eighteen (18) years of age, otherwise recognized as able to form legally binding contracts under applicable law, or are not barred from receiving the Services under applicable law.

If you are entering into this Agreement on behalf of an organization, you represent and warrant that you have the legal authority to bind that organization to these terms. If we determine you do not have authority, you will be personally responsible for obligations under this Agreement, including payment obligations. We are not liable for any loss or damage resulting from reliance on communication reasonably believed to be genuine and authorized.`,
  },
  {
    title: '4. YOUR ACCOUNT',
    content: `To access certain features of this Site or use certain Services, you must create an account. You represent that all information you provide is accurate, current, and complete, and you agree to keep it updated. If we believe your account information is inaccurate or incomplete, we may suspend or terminate your account.

You are responsible for activity that occurs on your account, whether authorized by you or not, and must keep your account secure, including your login, password, and payment information. Notify us immediately of any unauthorized use. We are not liable for losses due to unauthorized account use, and you may be liable for losses caused by your account, authorized use, or unauthorized use.`,
  },
  {
    title: '5. GENERAL RULES OF CONDUCT',
    content: `Your use of this Site and the Services must comply with this Agreement, applicable service terms, and all applicable laws and regulations.

You may not collect or harvest personal data about other users without express written consent, and you may not use the Site or Services in a manner that is illegal, promotes violence, spam, hacking, or prohibited content, infringes the rights of others, interferes with operation of the Site, installs harmful code, or contains false or deceptive information about Madurai School Education Commission or the Services.

You agree not to resell Services for commercial purposes without our prior written consent. You may be asked to verify your identity with government-issued identification when required, and you understand that calls regarding your account may be recorded subject to applicable law.`,
  },
  {
    title: '6. PROTECTION OF YOUR DATA',
    content: `We may process personal data about you, applicants, or school representatives in the course of delivering Services. We are committed to protecting personal data in accordance with applicable data privacy laws and apply appropriate safeguards for transfers of data, including cross-border transfers where required.`,
  },
  {
    title: '7. USER CONTENT',
    content: `Some features of this Site may allow users to share ideas, images, or other content. By posting content, you represent that you have the rights to do so and that it does not violate third-party rights.

You grant Madurai School Education Commission a worldwide, royalty-free license to reproduce, distribute, display, and perform your user content in connection with the Site and Services. You retain ownership of your content, but we may keep copies of removed content for backup and legal purposes.`,
  },
  {
    title: '8. AVAILABILITY OF WEBSITE/SERVICES',
    content: `We use commercially reasonable efforts to provide this Site and the Services continuously. However, the Site may be temporarily unavailable due to maintenance, technical problems, network issues, hostile attacks, or causes beyond our control. We assume no liability for outages or interruptions.`,
  },
  {
    title: '9. PRODUCT CREDITS',
    content: `If you receive a product credit, whether for a specific service purchase or as part of another transaction, the credit is valid for one year and may be terminated if the underlying product or service is cancelled, transferred, or not renewed. Credits may also be subject to automatic renewal at the then-current price unless cancelled.`,
  },
  {
    title: '10. MONITORING OF CONTENT; ACCOUNT TERMINATION POLICY',
    content: `We may monitor user content and reserve the right to remove content or terminate access for violations of this Agreement or our policies. Termination may occur immediately without prior notice.`,
  },
  {
    title: '11. DISCONTINUED SERVICES; END OF LIFE POLICY',
    content: `We may discontinue any Service or feature at any time. If a Service reaches end-of-life, we will attempt to provide at least 30 days notice. You are responsible for migrating your service before the end-of-life date, and we may offer comparable alternatives, prorated credit, or a prorated refund at our discretion.`,
  },
  {
    title: '12. BETA SERVICES',
    content: `Beta Services may be offered before full release. They may not function properly, may present operational risks, and are provided as-is. We may modify or discontinue Beta Services at any time, and feedback may be used by us for any purpose.`,
  },
  {
    title: '13. FEES AND PAYMENTS',
    content: `You agree to pay all amounts due for Services at the time of order. All amounts are non-refundable unless otherwise noted in the Refund Policy. Prices and fees may change at any time, and such changes will apply at renewal.

Payment methods may include credit card, UPI, wallets, or debit card, and your chosen method must remain valid for active Services. Refunds issued to your payment method are subject to your payment provider's processing time and may take several business days to post.`,
  },
  {
    title: '14. ADDITIONAL RESERVATION OF RIGHTS',
    content: `We reserve the right to deny, cancel, terminate, suspend, lock, or modify access to any Account or Service for any reason, including fraud, abuse, unlawful activity, or violation of this Agreement. We may review accounts for excessive usage and apply fees or termination as needed.`,
  },
  {
    title: '15. NO SPAM; LIQUIDATED DAMAGES',
    content: `Spam is prohibited. In addition to complying with applicable law, you must not send unsolicited commercial email, bulk email, or other prohibited communications through our Services. We may suspend or cancel accounts engaged in spam activity and may seek liquidated damages for violations.`,
  },
  {
    title: '16. LINKS TO THIRD-PARTY WEBSITES',
    content: `This Site may contain links to third-party websites not owned or controlled by us. We assume no responsibility for third-party content, terms, or privacy practices, and you should review those policies separately.`,
  },
  {
    title: '17. DISCLAIMER OF REPRESENTATIONS AND WARRANTIES',
    content: `This Site and the Services are provided “as is”, “as available” and “with all faults”. We disclaim all warranties, including implied warranties of merchantability, fitness for a particular purpose, and non-infringement. No oral or written information provided by us constitutes a warranty.`,
  },
  {
    title: '18. LIMITATION OF LIABILITY',
    content: `In no event shall we or our affiliates be liable for any direct, indirect, incidental, special, punitive, or consequential damages arising from your use of this Site or the Services. Our aggregate liability is limited to ₹10,000 or the minimum amount permitted by law, whichever is greater.`,
  },
  {
    title: '19. INDEMNITY',
    content: `You agree to indemnify and hold harmless Madurai School Education Commission and its affiliates from all claims, losses, liabilities, costs, and expenses arising from your use of this Site or your violation of this Agreement.`,
  },
  {
    title: '20. COMPLIANCE WITH LOCAL LAWS',
    content: `You are responsible for complying with all local laws and regulations when accessing this Site or using the Services. We make no representation that content is appropriate in every jurisdiction.`,
  },
  {
    title: '21. DISPUTES, BINDING INDIVIDUAL ARBITRATION AND WAIVER OF CLASS ACTIONS',
    content: `Any disputes between you and Madurai School Education Commission will be handled in accordance with the dispute resolution terms of this Agreement. Certain claims may be subject to individual arbitration rather than court proceedings.`,
  },
  {
    title: '22. SUCCESSORS AND ASSIGNS',
    content: `This Agreement is binding upon and benefits the parties and their respective successors and assigns.`,
  },
  {
    title: '23. NO THIRD-PARTY BENEFICIARIES',
    content: `Nothing in this Agreement creates rights for third parties.`,
  },
  {
    title: '24. TITLES AND HEADINGS; INDEPENDENT COVENANTS; SEVERABILITY',
    content: `Headings are for convenience only. Each covenant is separate and independent. If any provision is held invalid, the remaining provisions remain enforceable.`,
  },
  {
    title: '25. ENGLISH LANGUAGE CONTROLS',
    content: `This Agreement is executed in English. Translations are provided for convenience only; the English language version controls in case of conflict.`,
  },
  {
    title: '26. CONTACT INFORMATION',
    content: `If you have any questions about this Agreement, contact us at coordinator@mduschooled.in.`,
  },
];

export default function TermsOfService() {

   React.useEffect(() => {
      try {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      } catch (e) {
        window.scrollTo(0, 0);
      }
    }, []);

  return (
    <section className="terms-service-page">
      <div className="container terms-service-card">
        <div className="terms-service-header text-center mb-5">
          <h2>Terms of Service Agreement - Madurai School Education Commission</h2>
          <p className="terms-service-revised" style={{ textAlign: 'center' }}>Last Revised: 05-31-2026</p>
        </div>

        <p className="terms-service-intro">
          PLEASE READ THE TERMS OF SERVICE AGREEMENT CAREFULLY, AS IT CONTAINS IMPORTANT INFORMATION REGARDING YOUR LEGAL RIGHTS AND REMEDIES.
        </p>

        {termsSections.map((section) => (
          <article key={section.title} className="terms-service-section" style={{ marginBottom: '1.75rem' }}>
            <h3 style={{ color: '#0f172a', fontSize: '1.25rem', marginBottom: '0.9rem', fontWeight: 600 }}>{section.title}</h3>
            {section.content.split('\n\n').map((paragraph, index) => (
              <p key={index} style={{ color: '#475569', lineHeight: 1.85, marginBottom: '1rem' }}>{paragraph}</p>
            ))}
          </article>
        ))}
      </div>

      <style>{`
        .terms-service-page {
          background: #eef4fb;
          min-height: 100vh;
          padding: 80px 16px;
        }
        .terms-service-card {
          max-width: 920px;
          margin: 0 auto;
          background: #ffffff;
          border-radius: 32px;
          border: 1px solid rgba(148, 163, 184, 0.18);
          box-shadow: 0 32px 80px rgba(15, 23, 42, 0.08);
          padding: 56px;
          text-align: left;
        }
        .terms-service-header h2 {
          font-size: 2.6rem;
          font-weight: 800;
          color: #0f172a;
          letter-spacing: -0.03em;
          margin-bottom: 0.65rem;
          line-height: 1.1;
        }
        .terms-service-revised {
          color: #475569;
          font-size: 0.95rem;
          margin-bottom: 1rem;
        }
        .terms-service-intro {
          max-width: 760px;
          margin: 0 auto;
          color: #475569;
          font-size: 1.05rem;
          line-height: 1.9;
          text-align: justify;
          margin-bottom: 1.8rem;
        }
        .terms-service-card p,
        .terms-service-card li {
          color: #334155;
          line-height: 1.85;
          font-size: 1rem;
          margin-bottom: 1rem;
          text-align: justify;
        }
        .terms-service-card h3 {
          color: #0f172a;
          margin-top: 2.5rem;
          margin-bottom: 1rem;
          font-size: 1.55rem;
          font-weight: 700;
          letter-spacing: -0.02em;
        }
        .terms-service-list {
          list-style: disc outside;
          padding-left: 1.3rem;
          margin-bottom: 1.4rem;
          text-align: left;
        }
        .terms-service-list li {
          margin-bottom: 0.85rem;
        }
        .terms-service-card a {
          color: #2563eb;
          text-decoration: none;
          font-weight: 600;
        }
        .terms-service-card a:hover {
          text-decoration: underline;
        }
        .terms-service-card strong {
          color: #0f172a;
        }
        @media (max-width: 991px) {
          .terms-service-card {
            padding: 40px 28px;
          }
        }
        @media (max-width: 767.98px) {
          .terms-service-card {
            padding: 30px 20px;
            border-radius: 24px;
          }
          .terms-service-header h2 {
            font-size: 2rem;
          }
          .terms-service-intro {
            font-size: 1rem;
            margin-bottom: 1.6rem;
          }
        }
      `}</style>
    </section>
  );
}
